import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsuranceCompanyDetailComponent } from './insurance-companies-detail/insurance-companies-detail.component';
import { InsuranceCompanyListComponent } from './insurance-companies-list/insurance-companies-list.component';

const routes: Routes = [
    {
        path: 'insuranceCompanies',
        children: [
            { path: '', component: InsuranceCompanyListComponent }
        ]
    },
    {
        path: 'insuranceCompanies/:id',
        children: [
            { path: '', component: InsuranceCompanyDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InsuranceCompaniesRoutingModule { }
